import React, { useEffect, useState } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { MdError, MdOutlineUnsubscribe } from "react-icons/md";
import Api from "../services/ApiService";
import { useParams } from "react-router-dom";

const MissingDocumentUnsubPage = () => {

    const API = new Api();
    const { token } = useParams();
    const [view, setView] = useState("loading");
    const [apiError, setApiError] = useState("Unbekannter Fehler aufgetreten.")
    
    useEffect(() => {
        if (token === undefined || token === "") {
            setApiError("Falsches E-Mail token.")
            return setView("error");
        }
        API.missing_document_unsubscribe(token)
            .then(() => {
                setView("success");
            })
            .catch(err => {
                if (err.response.data.detail !== undefined) setApiError(err.response.data.detail);
                setView("error");
            })
    }, [token])

    return (
        <div className="bg-energo" style={{ width: "100%", height: "100vh", display:"flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{ maxWidth: "700px", width: "100%"}}>
                <Card style={{borderRadius: 15}} className="shadow-lg">
                    <Card.Body className="text-dark">
                        <Row className="text-center">
                            <Col>
                                {
                                    view === "success" ?
                                        <MdOutlineUnsubscribe className="text-energo" size={80}/> :
                                    view === "error" ?
                                        <MdError size={80} className="text-danger" /> :
                                    <Spinner animation="border" className="text-energo" />
                                }
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col>
                                {
                                    view === "success" ?
                                        <b>Die Abmeldung der Erinnerungsnachrichten war erfolgreich. Die von Ihnen eingegebenen Daten wurden gelöscht. <br />Vielen Dank!</b> :
                                    view === "error" ?
                                        <b className="text-danger">{apiError}</b>:

                                        <b>Daten werden gesammelt...</b>
                                }   
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col className="text-end" hidden={view !== "success"}>
                                <a style={{marginRight: 10}} className="btn btn-energo" href="/">ENERGO Kundenportal</a>
                                <a className="btn btn-energo" href="energiepool.at">ENERGO Website</a>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>
        </div>
    )
}

export default MissingDocumentUnsubPage;